import { render, staticRenderFns } from "./TradingPassDialog.vue?vue&type=template&id=4544925d&scoped=true"
import script from "./TradingPassDialog.vue?vue&type=script&lang=js"
export * from "./TradingPassDialog.vue?vue&type=script&lang=js"
import style0 from "./TradingPassDialog.vue?vue&type=style&index=0&id=4544925d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4544925d",
  null
  
)

export default component.exports